<template>
  <div>
<!--    <div class="wyziwyg-container fct-textarea">-->
<!--      <v-bar class="scroll-area" :settings="{suppressScrollX: true, useBothWheelAxes: true}">-->
<!--      <textarea class="content-area" :rows="rowsCount"-->
<!--                v-model="content"></textarea>-->
<!--      </v-bar>-->
<!--    </div>-->
    <div class="control">
      <label for="html">Article:</label>
      <wysiwyg v-model="content"></wysiwyg>
    </div>
    <counter :value="wordsCount" :min-count="minWords"></counter>
  </div>
</template>

<script>
  import Counter from './Counter'
  import Parser from "../../app/utils/parser";
  import Vue from 'vue'
  import wysiwyg from 'vue-wysiwyg'

  Vue.use(wysiwyg, {}); // config is optional. more below


  export default {
    components: {Counter},
    props: ['value', 'minWords'],
    computed: {
      rowsCount() {
        return  this.content.split(/\r*\n/).length + Math.ceil(this.wordsCount / 14) // temp
      },
      content: {
        get: function () {
          let adjustOldContent = function (str) {
            return str.replace(/\n/g, '<br>').replace(/\s\s+/g, ' ').replace(/(<\s*\/?\s*)div(\s*([^>]*)?\s*>)/gi ,'$1p$2')
          }
          return (adjustOldContent(this.value || '').match(/<p[^>]*>(.*?)<\/p>/g) || []).map(p => p.replace(/<\/?p>/g, "")).join('\n\n').replace(/<br\/?>/g, '\n')
        },
        set: function (val) {
          let set = val.split('\n\n').map(p => `<p>${p}</p>`).join('').replace(/(\r\n|\r|\n)/g, '<br/>')
          this.$emit('input', set)
        }
      },
      wordsCount: function () {
        return Parser.wordsCount(this.value)
      }
    },
  }
</script>

<style lang="scss">
  @import "../../node_modules/vue-wysiwyg/dist/vueWysiwyg.css";

  .wyziwyg-container {
    padding: 20px 10px 20px 20px !important;
    margin-bottom: 5px;

    .content-area {
      padding-right: 25px;
    }

    .scroll-area {
      height: 300px;
      position: relative;
      margin: auto;
      width: 100%;

      .ps .ps__scrollbar-x-rail {
        display: none !important;
      }


      //temp
      .ps__scrollbar-x-rail {
        display: none !important;

        > .ps__scrollbar-x {
          display: none !important;
        }
      }

      textarea {
        width: 100%;
        min-height: calc(100% - 6px);
        overflow: inherit;
        background-color: transparent;
        border: none;
        resize: none;

        &:focus {
          outline: none;
        }
      }
    }
  }
</style>
